import { forwardRef, HTMLProps } from 'react';
import { SizeType } from '../../types/props';
import cn from 'classnames';
import s from './checkbox.module.css';

export interface CheckboxProps extends Omit<HTMLProps<HTMLSpanElement>, 'size'> {
  size?: SizeType;
  label?: string;
  subLabel?: string;
  onClick?: () => void;
  checked?: boolean;
  partialArray?: boolean[];
  wrapperClassname?: string;
}

export const Checkbox = forwardRef<HTMLSpanElement, CheckboxProps>((props, ref) => {
  const {
    size = 'md',
    className,
    label,
    subLabel,
    onClick,
    checked = false,
    disabled,
    partialArray,
    tabIndex,
    wrapperClassname,
    ...other
  } = props;

  let checkState = '';
  if (partialArray) {
    const allNonChecked = partialArray.every((item) => !item);
    if (allNonChecked) checkState = 'none';

    const allChecked = partialArray.every((item) => item);
    if (allChecked) checkState = 'checked';

    if (!allChecked && !allNonChecked) checkState = 'partial';
  }

  return (
    <div className={cn(s.component)} tabIndex={disabled ? -1 : tabIndex}>
      <div className={cn(s.base, disabled && s.disabled, wrapperClassname)} onClick={onClick}>
        <span
          ref={ref}
          {...other}
          data-testid={other.id}
          className={cn(
            className,
            s.customCheckbox,
            checked && s.checked,
            s[size],
            !!partialArray?.length && s[checkState],
            disabled && s.disabled,
          )}
        />
        {label}
      </div>
      {subLabel}
    </div>
  );
});
